// extracted by mini-css-extract-plugin
export default {"root":"Code_root__iQUq5","centered":"Code_centered__mC8nz"};